import { Link } from 'react-router-dom'; // 1. IMPORT THE LINK COMPONENT

export default function HeroSection() {
  return (
    // This part remains unchanged
    <section className="relative h-screen min-h-[600px] max-h-[1200px] flex items-center -mt-24"> 
      
      {/* Background image */}
      <img
        src="/assets/images/hero-bg.png"
        alt="Illustration of an open orange gift box held in a hand, with playful orange swirls, flowers, and clouds on a pastel background."
        className="absolute inset-0 w-full h-full object-cover z-0"
        aria-hidden="true"
      />
      
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/30 z-0" />

      {/* Content */}
      <div className="container mx-auto py-4 relative z-10 text-white mt-24 px-4"> 
        <h1 className="text-5xl md:text-7xl font-extrabold mb-6 [text-shadow:0_2px_4px_rgba(0,0,0,0.5)]">
          Give the Gift of <br /> Independence
        </h1>
        <p className="text-lg md:text-xl max-w-2xl mb-8 [text-shadow:0_1px_3px_rgba(0,0,0,0.5)]">
          Your contribution can provide life-changing assistive technology to someone in need. Join us in making the world more accessible.
        </p>
        
        {/* 2. REPLACED <button> WITH <Link> AND ADDED to="/campaigns" */}
        <Link 
          to="/campaigns"
          className="bg-white text-orange-600 px-8 py-3 rounded-full font-bold hover:bg-gray-100 transition-colors inline-block"
          title="Explore all active donation campaigns"
        >
          View Campaigns
        </Link>
      </div>
    </section>
  );
}


